import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, CheckCircle, HelpCircle, XCircle, TrendingUp, Target, Calendar, BarChart3, ShieldCheck, DollarSign } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 bg-earia-bg-alt border-y border-earia-border" data-id="element-294">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-295">
        <div className="text-center mb-16" data-id="element-296">
          <h2 className="text-3xl md:text-4xl font-bold text-earia-text-heading mb-4" data-id="element-297">
            ¿Por qué EARIA?
          </h2>
          <p className="text-earia-text-body max-w-2xl mx-auto text-lg" data-id="element-298">
            No solo importamos tu vehículo — analizamos el mercado, tu
            presupuesto y tus objetivos para que cada dólar que inviertas tenga
            sentido.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-299">
          {/* WITHOUT Earia - Buying Blind */}
          <motion.div whileHover={{
          y: -5
        }} className="bg-earia-card border border-earia-danger/30 rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-all relative group" data-id="element-300">
            <div className="absolute top-0 inset-x-0 h-1 bg-earia-danger" data-id="element-301"></div>
            <div className="p-8" data-id="element-302">
              <div className="flex items-center justify-between mb-8" data-id="element-303">
                <h3 className="text-xl font-bold text-earia-text-heading" data-id="element-304">
                  Comprar a Ciegas
                </h3>
                <span className="bg-earia-danger/10 text-earia-danger text-xs font-bold px-3 py-1 rounded-full border border-earia-danger/20" data-id="element-305">
                  RIESGO ALTO
                </span>
              </div>

              <div className="space-y-5 text-sm" data-id="element-306">
                <div className="flex items-start gap-3 text-earia-text-body" data-id="element-307">
                  <XCircle className="w-5 h-5 text-earia-danger flex-shrink-0 mt-0.5" data-id="element-308" />
                  <div data-id="element-309">
                    <p className="font-medium text-earia-text-heading" data-id="element-310">
                      Eliges el carro equivocado
                    </p>
                    <p className="text-xs mt-0.5" data-id="element-311">
                      Sin análisis de mercado, compras lo que "se ve bien" sin
                      saber si es la mejor opción para tu presupuesto.
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3 text-earia-text-body" data-id="element-312">
                  <XCircle className="w-5 h-5 text-earia-danger flex-shrink-0 mt-0.5" data-id="element-313" />
                  <div data-id="element-314">
                    <p className="font-medium text-earia-text-heading" data-id="element-315">
                      Compras en el peor momento
                    </p>
                    <p className="text-xs mt-0.5" data-id="element-316">
                      No sabes cuándo los precios bajan o suben. Terminas
                      pagando de más por no esperar la temporada correcta.
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3 text-earia-text-body" data-id="element-317">
                  <XCircle className="w-5 h-5 text-earia-danger flex-shrink-0 mt-0.5" data-id="element-318" />
                  <div data-id="element-319">
                    <p className="font-medium text-earia-text-heading" data-id="element-320">
                      No sabes si es buena inversión
                    </p>
                    <p className="text-xs mt-0.5" data-id="element-321">
                      ¿Vas a revender? ¿Es para uso personal? Sin un análisis,
                      no sabes si el carro vale lo que estás pagando.
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3 text-earia-text-body" data-id="element-322">
                  <XCircle className="w-5 h-5 text-earia-danger flex-shrink-0 mt-0.5" data-id="element-323" />
                  <div data-id="element-324">
                    <p className="font-medium text-earia-text-heading" data-id="element-325">
                      Costos que no esperabas
                    </p>
                    <p className="text-xs mt-0.5" data-id="element-326">
                      Reparaciones ocultas, impuestos mal calculados, y un total
                      final que no tiene nada que ver con lo que planeaste.
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-8 pt-6 border-t border-earia-border" data-id="element-327">
                <div className="flex items-center justify-center gap-2 text-earia-danger/80 text-sm" data-id="element-328">
                  <AlertTriangle className="w-4 h-4" data-id="element-329" />
                  <span data-id="element-330">Tu dinero en riesgo sin estrategia</span>
                </div>
              </div>
            </div>
          </motion.div>

          {/* WITH Earia - Strategic Buying */}
          <motion.div whileHover={{
          y: -5
        }} className="bg-earia-card border border-earia-success/30 rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-all relative" data-id="element-331">
            <div className="absolute top-0 inset-x-0 h-1 bg-earia-success" data-id="element-332"></div>
            <div className="p-8" data-id="element-333">
              <div className="flex items-center justify-between mb-8" data-id="element-334">
                <h3 className="text-xl font-bold text-earia-text-heading" data-id="element-335">
                  Con Análisis Earia
                </h3>
                <span className="bg-earia-success/10 text-earia-success text-xs font-bold px-3 py-1 rounded-full border border-earia-success/20" data-id="element-336">
                  INVERSIÓN INTELIGENTE
                </span>
              </div>

              <div className="space-y-5 text-sm" data-id="element-337">
                <div className="flex items-start gap-3 text-earia-text-body" data-id="element-338">
                  <Target className="w-5 h-5 text-earia-success flex-shrink-0 mt-0.5" data-id="element-339" />
                  <div data-id="element-340">
                    <p className="font-medium text-earia-text-heading" data-id="element-341">
                      El carro correcto para vos
                    </p>
                    <p className="text-xs mt-0.5" data-id="element-342">
                      Analizamos tu presupuesto, necesidades y objetivo de uso
                      para recomendarte las mejores opciones.
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3 text-earia-text-body" data-id="element-343">
                  <Calendar className="w-5 h-5 text-earia-success flex-shrink-0 mt-0.5" data-id="element-344" />
                  <div data-id="element-345">
                    <p className="font-medium text-earia-text-heading" data-id="element-346">
                      Timing de mercado a tu favor
                    </p>
                    <p className="text-xs mt-0.5" data-id="element-347">
                      Te asesoramos sobre la mejor temporada para comprar o
                      vender, aprovechando ciclos de precios en subastas y
                      mercado.
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3 text-earia-text-body" data-id="element-348">
                  <TrendingUp className="w-5 h-5 text-earia-success flex-shrink-0 mt-0.5" data-id="element-349" />
                  <div data-id="element-350">
                    <p className="font-medium text-earia-text-heading" data-id="element-351">
                      Inversión protegida
                    </p>
                    <p className="text-xs mt-0.5" data-id="element-352">
                      Ya sea para reventa o uso propio, te aseguro que el
                      vehículo vale lo que pagas — con números reales, no
                      suposiciones.
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3 text-earia-text-body" data-id="element-353">
                  <BarChart3 className="w-5 h-5 text-earia-success flex-shrink-0 mt-0.5" data-id="element-354" />
                  <div data-id="element-355">
                    <p className="font-medium text-earia-text-heading" data-id="element-356">
                      Desglose total transparente
                    </p>
                    <p className="text-xs mt-0.5" data-id="element-357">
                      Cada costo detallado antes de comprar: subasta, impuestos,
                      flete, reparación y comisión. Sin sorpresas.
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-8 pt-6 border-t border-earia-border" data-id="element-358">
                <div className="flex items-center justify-center gap-2 text-earia-success text-sm font-medium" data-id="element-359">
                  <ShieldCheck className="w-4 h-4" data-id="element-360" />
                  <span data-id="element-361">Cada dólar invertido con estrategia</span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}